import * as types from './item.types';
import * as constants from './item.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeItem = generateStoreResourceAction<types.IItem>(constants.STORE_ITEM);
export const clearItem = generateClearResourceAction(constants.CLEAR_ITEM);
